import jwtDecode from 'jwt-decode';
import { IAuth0JSONWebToken } from 'types/accessControl/IAuth0JSONWebToken';

export const decodeOurJWT = (jwt: string) => jwtDecode<IAuth0JSONWebToken>(jwt);
